import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import type { Entity } from '../../../core/models/entity.model';
import { map, Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectEntityType } from '../../../core/store/entity-types/entity-types.selectors';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-delete-dialog',
  templateUrl: './confirm-delete-dialog.component.html',
  styleUrls: ['./confirm-delete-dialog.component.scss'],
  standalone: false
})
export class ConfirmDeleteDialogComponent {
  entityName$: Observable<string>;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>,
    store: Store,
    translator: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: Entity
  ) {
    // Get the entity name. If the entity has no name property, then use the entity type name
    const nameProperty = data.Properties['Name'];
    if (nameProperty?.Value) {
      this.entityName$ = of(nameProperty.Value as string);
    } else {
      this.entityName$ = store.select(selectEntityType(data.EntityTypeKey)).pipe(map(entityType => translator.instant(entityType.NameId)));
    }
  }
}
